import React, { useEffect } from 'react';
import '../styles/globals.css';
import '../styles/about.css';
import '../styles/docs.css';
import '../styles/pricing.css';
import '../styles/waitlist.css';
import '../styles/mobile-nav-fix.css';
import Head from 'next/head';
import type { AppProps } from 'next/app';
// import { AuthProvider } from "react-oidc-context";
import { FirebaseProvider } from '../lib/firebaseContext';
// const isProduction = process.env.NODE_ENV === 'production' || false;

// const cognitoAuthConfig = {
//   authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_kGpCneMkn",
//   client_id: "3sfcb333cq6p7aug0lsu13q592",
//   redirect_uri: isProduction ? "https://lvl3.ai/" : "http://localhost:3000/",
//   response_type: "code",
//   scope: "email openid phone",
// };
export default function App({ Component, pageProps }: AppProps) {
    useEffect(() => {
    const initClarity = async () => {
      if (typeof window !== 'undefined') {
        const { default: Clarity } = await import('@microsoft/clarity');
        const projectId = 't2fedunb7s';
        Clarity.init(projectId);
      }
    };

    initClarity();
  }, []);
  return (
    <>
      <Head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
        <meta name="theme-color" content="#030304" />
        <meta name="description" content="LVL3.ai - Advanced AI solutions for developers" />
        <title>LVL3.ai</title>
      </Head>
        <FirebaseProvider>
          <Component {...pageProps} />
        </FirebaseProvider>
    </>
  );
} 